import React from "react";
import url from "../helpers/url";
import axios from "axios";
import { Paginate } from "../helpers/helpers";
import { useMediaQuery } from "react-responsive";
import { Hot } from "../helpers/helpers";
import { UserContext } from "../context/user";

export const DishesContext = React.createContext();

const DishesProvider = (props) => {
  const { loading, setLoading } = React.useContext(UserContext);

  const fetchData = async () => {
    setLoading(true);
    let response = await axios.get(`${url}/dishes`).catch((error) => {
      console.clear();
    });
    if (response) {
      const dishes = response.data;
      const bestdeals = Hot(response.data);
      setBestDeals(bestdeals);
      setSorted(Paginate(dishes));
      setDishes(dishes);
      setLoading(false);
    } else {
      console.clear();
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  const [dishes, setDishes] = React.useState([]);
  const [sorted, setSorted] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [bestdeals, setBestDeals] = React.useState([]);

  const update_filters = (e) => {
    const type = e.target.type;
    const value = e.target.value;
    const filter = e.target.name;
    let filterValues;
    if (type === "checkbox") {
      filterValues = e.target.checked;
    } else if (type === "radio") {
       value === 'all'
        ? (filterValues = value)
        : (filterValues = parseInt(value));
    } else {
      filterValues = value;
    }
    setFilters({ ...filters, [filter]: filterValues });
  };

  const [filters, setFilters] = React.useState({
    search: "",
    category: "all",
    price: "all",
  });

  React.useEffect(() => {
    let filtering = [...dishes];
    let { search, price, category} = filters;
    if (category !== "all") {
      filtering = filtering.filter((item) => item.category === category);
    }
    if (price !== "all") {
      filtering = filtering.filter((item) => {
        if (price === 0) {
          return item.price_small > 0 && item.price_small < 10;
        } else if (price === 10) {
          return item.price_small > 10 && item.price_small < 20;
        } else {
          return item.price_small > 20;
        }
      });
    }
    if (search !== "") {
      filtering = filtering.filter((item) => {
        let title = item.Title.toLowerCase().trim();
        return title.startsWith(search) ? item : null;
      });
    }
    setSorted(Paginate(filtering));
  }, [dishes, filters]);

  const phone_screen = useMediaQuery({ query: "(max-device-width: 540px)" });
  const medium_phone_screen = useMediaQuery({
    query: "(max-device-width: 700px)",
  });

  return (
    <DishesContext.Provider
      value={{
        dishes,
        loading,
        update_filters,
        filters,
        sorted,
        phone_screen,
        medium_phone_screen,
        page,
        setPage,
        bestdeals,
      }}
    >
      {props.children}
    </DishesContext.Provider>
  );
};

export { DishesProvider as default };
